(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p5-live-region"] && !Shopify.designMode) return;
  try {
    (() => {
  const bar = document.querySelector('[data-p5-region]');
  if (!bar) return;
  let dismissed = false;
  try { dismissed = localStorage.getItem('p5-live-region-choice') === '1'; } catch (_) {}
  bar.hidden = dismissed;
  bar.addEventListener('click', event => {
    if (!event.target.closest('[data-p5-region-choice]')) return;
    try { localStorage.setItem('p5-live-region-choice','1'); } catch (_) {}
    bar.hidden = true;
  });
})();
  } catch(e) { console.error(e); }
})();

})();
